export function enxLog(data) {
    console.log('%c%s', 'color: #000000; background: #91d5ff; font-size: 16px;', `${data}`);
}


export const VIRTUAL_BACKGROUND_TYPE = {
    IMAGE: 'vb',
    BLUR: 'blur',
    NONE: 'none'
};